var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDisconnectIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18.581,
    viewBox: "0 0 18 18.581",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Disconnect_18px",
    transform: "translate(-432 -96)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_897",
    "data-name": "Rectangle 897",
    width: 18,
    height: 18,
    transform: "translate(432 96)",
    fill: "#ffd1d1",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "Disconnect-18px",
    transform: "translate(432 96.497)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1099",
    d: "M16.264,1.56,10.559,7.337,1.06,16.98",
    transform: "translate(0.03 0.044)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse_98",
    d: "M2.629,11.265A6.381,6.381,0,0,1,2.31,9.271a6.269,6.269,0,0,1,8.707-5.777",
    transform: "translate(0.065 0.084)",
    fill: "none",
    stroke: "#0d0d0d",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse_98-2",
    d: "M14.215,6.33a8.352,8.352,0,0,1,.535,2.848,6.269,6.269,0,0,1-6.271,6.271,4.36,4.36,0,0,1-2.889-.689",
    transform: "translate(0.156 0.177)",
    fill: "none",
    stroke: "#0d0d0d",
    strokeLinecap: "round",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_99",
    cx: 3.187,
    cy: 3.187,
    r: 3.187,
    transform: "translate(5.459 0)",
    fill: "#0d0d0d"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_101",
    cx: 3.187,
    cy: 3.187,
    r: 3.187,
    transform: "translate(11.626 10.588)",
    fill: "#0d0d0d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1100",
    "data-name": "Path 1100",
    d: "M5.13,10.938A3.17,3.17,0,0,0,0,13.447,3.118,3.118,0,0,0,.678,15.39L5.13,10.938Z",
    transform: "translate(0 0.287)",
    fill: "#0d0d0d"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisconnectIcon);
export default __webpack_public_path__ + "static/media/disconnect-icon.26cd2278b9fb10e573d611595dfd57af.svg";
export { ForwardRef as ReactComponent };